import { type NavigateFunction } from 'react-router';

let navigate: NavigateFunction;
let appNavigate: NavigateFunction;

export const setNavigate = (
  nav: NavigateFunction,
  appNav: NavigateFunction
) => {
  navigate = nav;
  appNavigate = appNav;
};

export const getNavigate = () => navigate;
export const getAppNavigate = () => appNavigate;
